import { Cookie } from '@/utils/functions/cookie'
import { IUserData } from '@/utils/types'
import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

interface IAuthData {
  isAuth?: boolean
  token: string
  refreshToken: string
  user?: IUserData
}
interface AuthState {
  authData: IAuthData
  setAuthData: (user: IAuthData) => void
  setAuthUserData: (user: IUserData) => void
  logoutUser: () => void
}

const useAuthStore = create<AuthState>()(
  devtools(
    persist(
      (set) => ({
        authData: { token: '', isAuth: false } as IAuthData,
        setAuthData: (data: IAuthData) =>
          set((state) => ({
            ...state,
            authData: { ...data, isAuth: data.token ? true : false },
          })),
        setAuthUserData: (user: IUserData) =>
          set((state) => ({
            ...state,
            authData: {
              ...state.authData,
              user: {
                ...state.authData.user,
                ...user,
              },
            },
          })),
        logoutUser: () =>
          set((state) => {
            Cookie.remove('token')

            return {
              ...state,
              authData: { token: '', isAuth: false } as IAuthData,
            }
          }),
      }),
      { name: 'authStore' },
    ),
  ),
)

export default useAuthStore
